import script from "./SandBoxMaterialItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SandBoxMaterialItem.vue?vue&type=script&setup=true&lang=js"

import "./SandBoxMaterialItem.vue?vue&type=style&index=0&id=fea87d30&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fea87d30"]])

export default __exports__